<template>
  <div id="app">
    <AppNavbar v-if="showNavbar"></AppNavbar>
    <router-view class="router-view"></router-view>
  </div>
</template>

<script>
import AppNavbar from '@/components/AppNavbar';

export default {
  name: 'App',
  components: {
    AppNavbar
  },

  computed: {
    showNavbar() {
      return this.$store.getters.isLoggedIn && !(this.$route.name === 'Login');
    }
  }
};
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,100;0,300;0,400;0,700;0,900;1,100;1,300;1,400;1,700;1,900&display=swap'); // Lato font
@import url('https://fonts.googleapis.com/css2?family=IBM+Plex+Mono:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;1,100;1,200;1,300;1,400;1,500;1,600;1,700&display=swap');

#app {
  height: 100%;
  font-family: 'Lato', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

h1.card-title {
  font-family: 'IBM Plex Mono', monospace;
}

.router-view::before {
  content: '';
  display: block;
  width: 100%;
  height: 50px;
}

.router-view {
  height: 100%;
  position: relative;
}

.error {
  text-align: center;
  margin: 0;
  position: absolute;
  top: calc(50% - 50px);
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>
